<template>
  <div class="c-select">
    <validation-message 
			:valid="valid"
			:invalid="isInvalid"
			:validationMessage="validationMessage"
		>

			<div class="c-select__group">
				<div class="c-select__container">
					<label class="c-select__label" :for="id">
						<select
							class="c-select__field"
							:class="{ 'is-active': hasValue }" 
              :id="id"
							:name="id"
							:required="required"
							:disabled="disabled"
							v-model="internalValue"
              @input="valueUpdated">
							<option v-if="placeholder" disabled>{{ placeholder }}</option>
							<option
								v-for="option in options"
								:key="option.value"
								:value="option.value">
								{{ option.label }}
							</option>
						</select>
						<span class="c-select__label-text">{{ label }}  <span v-if="required" class="c-select__required"> *</span></span>
						<svg class="c-select__icon" aria-hidden="true" focusable="false">
							<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#chevron-down"></use>
						</svg>
					</label>
				</div>
			</div>

		</validation-message>
  </div>
</template>

<script>
import ValidationMessage from '../../../../base/validation-message/ValidationMessage.vue';
export default {
	components: { ValidationMessage },
  inheritAttrs: false,
  props: {
    id: {
      required: true,
      type: String,
    },
    label: {
      required: true,
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
    required: {
      default: false,
      required: false,
      type: Boolean,
    },
    validationError: {
      default: false,
      required: false,
      type: Boolean,
    },
    validationMessage: {
      required: false,
      type: String,
    },
		valid: {
      type: Boolean,
      default: null
    },
		invalid: {
      type: Boolean,
      default: null
    },
    value: {
      type: [String, Number],
    },
  },
  computed: {
    errorId() {
      return `${this.id}ErrorMsg`;
    },
    requiredCssClass() {
      return this.required ? 'c-form-select__label--required' : '';
    },
		hasValue(){
			return this.internalValue !== '' && this.internalValue !== null && this.internalValue !== undefined;
		},
		isInvalid(){
			return this.validationError ? true : this.invalid
		}
  },
	watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  data() {
    return {
      internalValue: this.value,
    };
  },
  methods: {
    valueUpdated() {
      this.$emit('change', this.internalValue);
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/components/reportAProblem/_contact-us-rap/_vue/FormSelect.vue